import { Units } from 'ol/control/ScaleLine';

export const REGION_FILTER = 'RegionName';
export const ROUTE_FILTER = 'RouteName';
export const MDU_FILTER = 'MDUName';
export const WEATHER_STATION = 'WeatherStation';
export const CAPTION = ['Fire severity index - (24 hours)', 'Steam Risk Index - (24 hours)'];

export const OBSERVED_TABLE = {
  tableHeader: {
    precipitation: ['Precipitation (mm)'],
    wind: ['Wind Gust (mph)', 'Wind Speed (mph)', 'Wind Direction'],
    snow: ['Snow Depth (mm)'],
  },
  tableTitle: {
    precipitation: 'Precipitation Observation (Past Hour)',
    wind: 'Wind Observation (Past hour)',
    snow: 'Snow Depth (Past hour)',
  },
};

export const DASHBOARD_OBSERVED_API_NAME = [
  {
    apiname: 'precipitation/observed-data',
    id: 7,
    keyname: 'getObservedPrecipitationDataPoints',
  },
  {
    apiname: 'air-temp/observed-data',
    id: 12,
    keyname: 'getObservedAirTempMaxDataPoints',
  },
  {
    apiname: 'wind/observed-windspeed-data',
    id: 9,
    keyname: 'getObservedWindspeedDataPoints',
  },
  {
    apiname: 'wind/observed-windgust-data',
    id: 11,
    keyname: 'getObservedWindgustDataPoints',
  },
  {
    apiname: 'snow/observed/data-point',
    id: 20,
    keyname: 'getObservedSnowDataPoints',
  },
];

export const DASHBOARD_FORECAST_DATA_PTS_API_NAME = [
  {
    apiname: 'air-temp/forecast-max-data', // For Air Temp Maximum data pts
    id: 12,
    keyname: 'getForecastAirTempMaxDataPoints',
  },
  {
    apiname: 'air-temp/forecast-min-data', // For Air Temp Minimum data pts
    id: 13,
    keyname: 'getForecastAirTempMinDataPoints',
  },
  {
    apiname: 'humidity/forecast-data', // For Humidity data pts
    id: 14,
    keyname: 'getForecastHumidityDataPoints',
  },
  {
    apiname: 'wind/windspeed-forecast-datapoints', //for Wind Speed data pts
    id: 9,
    keyname: 'getForecastWindspeedDataPoints',
  },
  {
    apiname: 'wind/windgust-forecast-datapoints', //for Wind Gusts data pts
    id: 11,
    keyname: 'getForecastWindgustDataPoints',
  },
  {
    apiname: 'snow/forecast/data-point', //for Snow data pts
    id: 21,
    keyname: 'getForecastSnowDataPoints',
  },
  {
    apiname: 'snow/forecast/data-point', //for Snow data pts
    id: 22,
    keyname: 'getForecastSnowDataPoints',
  },
];

export const DATETIME_FORMAT = {
  DEFAULT_DATE: 'DD/MM/YYYY', //=>28/11/2023
  DEFAULT_DATE_HOUR: 'DD/MM/YYYY HH00',
  DEFAULT_TIME: 'hh:mm:ss', //=>15:33:54
  DEFAULT_DATETIME: 'DD/MM/YYYY hh:mm:ss', //=>28/11/2023 15:33:54
  API_DATE: 'YYYY-MM-DD', //=>2023-11-28
};

export const INITIAL_USER = {
  id: '',
  name: '',
  username: '',
  email: '',
  region: '',
  route: '',
  mdu: '',
  designation: '',
  firstLogin: false,
  regionId: 0,
  routeId: 0,
};

export const FAMILIARISATION_DOCUMENT_LINK =
  'https://networkrail.sharepoint.com/sites/ROWSHelp/Shared%20Documents/Forms/AllItems.aspx?id=%2fsites%2fROWSHelp%2fShared%20Documents%2fUser%20familiarisation%20induction%2fUser%20Familiarisation%20Document%20for%20ROWS%20test%20template.pdf&parent=%2fsites%2fROWSHelp%2fShared%20Documents%2fUser%20familiarisation%20induction';

export const USER_GROUP_ID = {
  ADMIN: '0cfbea5c-9982-43fd-9d9c-64d11c9b9dd7',
  USER: 'b1bc3c41-b5e0-49ea-b36b-4cb99daf020e',
};

export const UNSAVED_CHANGES_MESSAGE = 'Your changes will be lost. Do you want to continue?';

/**
 * GIS Constants Start
 */

export const MAP_INITIAL_ZOOM_LEVEL = 6.5;
export const MAP_PROJECTION = 'EPSG:27700';
export const MAP_INITIAL_CENTRE = [324606.5455876154, 504257.47867447487];
export const MAP_UK_EXTENT = [1393.0196, 13494.9764, 671196.3657, 1230275.0454];
export const VECTOR_SOURCE_WMS = 'wms';
export const VECTOR_SOURCE_WFS = 'WFS';
export const VECTOR_SOURCE_API = 'API';
export const BASE_MAP_XYZ = 'XYZ_LAYER';
export const BASE_MAP_OSM = 'OSM_LAYER';
export const VECTOR_SOURCE_CLASS_NAME = 'CLASS_NAME';
export const VECTOR_SOURCE_WORK_BENCH = 'workbench';
export const MAP_LAYER_NAME = 'layer_name';
export const LAYER_GEOSERVER = 'geoserver';
export const ARRAY_BUFFER = 'arraybuffer';
export const VECTOR_LAYER_CLASS_NAME_KEY = 'layer_name';
export const LAYER_TRANSPARENCY = 'layer_opacity';
export const VECTOR_LAYER_CLASS_NAME_VALUE = 'VECTOR_LAYER';
export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const WEATHER_VALUE = 'value';
export const Map_Scale_Units: Units = 'metric'; //Map Scale Control Units
export const Map_Scale_steps = 4; //Map Scale Control Steps
export const Map_Scale_Min_Width = 140; //Map Scale Control Min Width
export const Map_Highlight_Layer = 'hight_layer';
export const Geometry_Type_Polygon = 'Polygon';
export const Geometry_Type_Multi_Polygon = 'MultiPolygon';
export const Geometry_Type_Line = 'Line';
export const Geometry_Type_Point = 'Point';
export const Highlight_Polygon_Style = {
  strokeColor: '#18f8f3',
  strokeWidth: 3,
  fillColor: '#00000000',
};
export const CAT_CELL_STYLE = {
  strokeColor: '#D3D3D3',
  strokeWidth: 1,
  fillColor: '#000000',
};
export const ORS_POINT_STYLE = {
  strokeColor: '#000000',
  strokeWidth: 2,
  fillColor: '#000000',
  radius: 6,
};
export const SHOW_INFO_WINDOW = 'show_info_window';
export const SHOW_SELECTED_TILE_DETAILS = 'show_selected_tile_details';
export const YARDS_TO_CHAINS = 'Yards to Chains';
export const MILEAGE_TO_CHAIN = 'Mileage to Chains';
export const MILEAGE_TO_YARD = 'Mileage to Yards';
export const DEFAULT_LEGEND_TITLE = 'Convective Rainfall Accumulation Alert Levels';
export const CAT_CELL_NAME = 'cellname';
export const CAT_CELL_ID = 'ID';
export const WEATHER_PARAMETERS = {
  CAT: 'CAT',
  FSR: 'FSR',
};
export const ORS_SECTION = 'orsname';
export const ORS_SEVERITY = 'sevname';
export const TILES_LAYER_NAME = 'Tiles';
export const ORS_LAYER_NAME = 'ORS Points';
export const HIGHLIGHT_FEATURE = 'highlight_feature';
export const FIRE_RISK_INDEX = 'FRI';
export const STEAM_RISK_INDEX = 'SRI';
export const LAYER_VISIBLE_SCALES = {
  Region: { minScale: 4000000, maxScale: 10000000 },
  Route: { minScale: 2001000, maxScale: 4000000 },
  FORECAST_AREAS: { minScale: 0, maxScale: 2000000 },
};

export const DEFAULT_POLYGON_STYLE = {
  strokeColor: '#000000',
  strokeWidth: 1,
  fillColor: '#00000000',
};

export const RAG_ATTRIBUTE = 'rag_attribute';
export const FEATURE_ATTRIBUTE = 'feature_attribute';
export const RAG_OBJECT = 'rag_object';
export const IS_RAG_LAYER = 'is_rag_layer';
export const RAG_DETAILS = 'rag_details';
export const GEOMETRY_TYPE = 'Geometry_Type';

export const IMAGE = 'IMAGE';
export const RadarLayer = 'Radar';
export const TWO_KM_POINT_LABEL = '2KM_POINT_Label';

/**
 * GIS Constants End
 */
